export function sum(a, b){
  return a + b;
}

export function sub(a, b){
  return a - b;
}

export function mul(a, b){
  return a * b;
}



// WEBPACK FOOTER //
// ./build/assets/js/modules/math.js